import { useIsAuthorized } from '@modules/common/components/CanAccess/hooks';
import { trackManageUnifiedFieldsPageEvent } from '@modules/integrationsV2/utils/trackManageUnifiedFieldsPageEvent';
import { AddRounded } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { useState } from 'react';
import { CreateUnifiedFieldDrawer } from '../CreateUnifiedFieldDrawer';

export const CreateNewUnifiedFieldButton = () => {
  const [
    shouldOpenCreateUnifiedFieldDrawer,
    setShouldOpenCreateUnifiedFieldDrawer,
  ] = useState(false);

  const isAuthorized = useIsAuthorized({
    operation: PermissionOperation.Write,
    resource: PermissionResource.Metadata,
  });

  if (!isAuthorized) {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddRounded />}
        onClick={() => {
          setShouldOpenCreateUnifiedFieldDrawer(true);
          trackManageUnifiedFieldsPageEvent({
            eventName:
              'Manage Unified Field - Create New Unified Field Button Clicked',
          });
        }}
      >
        Create new Unified Field
      </Button>
      <CreateUnifiedFieldDrawer
        open={shouldOpenCreateUnifiedFieldDrawer}
        onClose={() => setShouldOpenCreateUnifiedFieldDrawer(false)}
      />
    </>
  );
};
